module.exports = "<h5>Payment</h5>"


//////////////////
// WEBPACK FOOTER
// ./app/topup/payment.html
// module id = 323
// module chunks = 0